import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux"
import ReactApexChart from "react-apexcharts"
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { httpOk, GET } from 'helpers/api'
import { formatMoney } from 'helpers/helpers';

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({})
	const [grossIncome, setGrossIncome] = useState({
		series: [
			{
				name: t('sales'),
				data: [],
				yAxis: 0
			},
			{
				name: t('cheques'),
				data: [],
				yAxis: 1
			}
		],
		options: {
			colors: ['#34c38f', '#f1b44c'],
			chart: {
				height: 350,
				type: 'line',
				toolbar: {
					show: false
				},
				background: '#fff',
			},
			legend: {
				show: false
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'straight'
			},
			markers: {
				size: 5,
				colors: undefined,
				strokeWidth: 0,
				shape: "circle",
			},
			yaxis: [
				{
					title: { text: t('sales') },
					labels: {
						formatter: value => formatMoney(value, 0)
					}
				},
				{
					opposite: true,
					title: { text: t('cheques') },
					labels: {
						formatter: value => formatMoney(value, 0)
					}
				}
			],
			xaxis: {
				tooltip: {
					enabled: false
				},
				categories: []
			},
			tooltip: {
			},
		},
	})
	const [chequeTypes, setChequeTypes] = useState({
		series: [1, 1, 1, 1, 1, 1],
		options: {
			colors: ['#34c38f', '#f1b44c', '#f46a6a'],
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [t('hall'), t('takeaway'), t('delivery')],
			legend: {
				show: false
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'smooth'
			},

		},
	}
	)
	const [show] = useState(!false)
	const [loader, setLoader] = useState(true)

	async function getData() {
		const response = await GET(`/dashboard-main-info?pos_id=${reduxAccount.pos_id}`)
		if (httpOk(response)) {
			setData(response.data)
			setChequeTypes({ ...chequeTypes, 'series': response.data.order_types.series })

			var grossIncomeCopy = { ...grossIncome }

			grossIncomeCopy.series[0]['data'] = response.data.chart_sales['series_sales']
			grossIncomeCopy.series[1]['data'] = response.data.chart_sales['series_cheqeus']
			grossIncomeCopy.options.xaxis.categories = response.data.chart_sales['series_hours']

			setGrossIncome(grossIncomeCopy)
			setLoader(false)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{show &&
				<>
					{!loader &&
						<>
							<div className="d-flex align-items-center gap-3 mb-3">
								<div className="w-100 mb-3" style={{ 'height': '85px' }}>
									<div className="card h-100 bg-primary-gradient">
										<div className="px-3 pt-3 pb-2 pt-0">
											<div className="d-flex justify-content-between">
												<h6 className="mb-3 text-white">{t('sales')}</h6>
											</div>
											<div className="d-flex text-white">
												<div className="w-75">
													<h4 className="text-nowrap text-white">
														<b>{formatMoney(data.sales)}</b>
													</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="w-100 mb-3" style={{ 'height': '85px' }}>
									<div className="card h-100 bg-danger-gradient">
										<div className="px-3 pt-3 pb-2 pt-0">
											<div className="d-flex justify-content-between">
												<h6 className="mb-3 text-white">{t('cheques')}</h6>
											</div>
											<div className="d-flex text-white">
												<div className="w-75">
													<h4 className="text-nowrap text-white">
														<b>{formatMoney(data.total_cheque)}</b>
													</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="w-100 mb-3" style={{ 'height': '85px' }}>
									<div className="card h-100 bg-warning-gradient">
										<div className="px-3 pt-3 pb-2 pt-0">
											<div className="d-flex justify-content-between">
												<h6 className="mb-3 text-white">{t('average_check')}</h6>
											</div>
											<div className="d-flex text-white">
												<div className="w-75">
													<h4 className="text-nowrap text-white">
														<b>{formatMoney(data.average_cheque)}</b>
													</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="w-100 mb-3" style={{ 'height': '85px' }}>
									<div className="card h-100 bg-success-gradient">
										<div className="h-100 px-3 pt-3 pb-2 pt-0">
											<div className="h-100 d-flex flex-column justify-content-center">
												<h6 className="text-nowrap text-white">
													<b>{t('products')}: {formatMoney(data.count_products)}</b>
												</h6>
												<h6 className="text-nowrap text-white">
													<b>{t('clients')}: {formatMoney(data.count_unique_clients)}</b>
												</h6>
											</div>
										</div>
									</div>
								</div>
								<div className="w-100 mb-3" style={{ 'height': '85px' }}>
									<div className="card h-100 bg-danger-gradient">
										<div className="h-100 px-3 pt-3 pb-2 pt-0">
											<div className="h-100 d-flex flex-column justify-content-center">
												<h6 className="text-nowrap text-white">
													<b>{t('number_of_checks')} [ {t('deleted')} ]: {formatMoney(data.count_deleted_cheques)}</b>
												</h6>
												<h6 className="text-nowrap text-white">
													<b>{t('number_of_products')} [ {t('deleted')} ]: {formatMoney(data.count_deleted_products)}</b>
												</h6>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row mb-3">
								<div className="col-md-12">
									<div className="card">
										<div className="card-body">
											<div className="d-flex justify-content-between">
												<h4>{t('sales')}</h4>
											</div>
											<hr />
											<ReactApexChart
												options={grossIncome.options}
												series={grossIncome.series}
												type="line"
												height={300} />
										</div>
									</div>
								</div>
							</div>
							<div className="row mb-5">
								<div className="col-md-4 mb-3">
									<div className="card h-100">
										<div className="card-body">
											<div>
												<h4>{t('order_type')}</h4>
											</div>
											<div className="d-flex justify-content-center">
												<ReactApexChart options={chequeTypes.options} series={chequeTypes.series} type="pie" width={250} height={250} />
											</div>
											<div className="d-flex justify-content-between">
												<div className="d-flex">
													<div className="chart-legend-color bg-success"></div>
													{t('hall')}
												</div>
												<div>{formatMoney(data.order_types.total_hall)} %</div>
											</div>
											<div className="d-flex justify-content-between">
												<div className="d-flex">
													<div className="chart-legend-color bg-warning"></div>
													{t('takeaway')}
												</div>
												<div>{formatMoney(data.order_types.total_takeaway)} %</div>
											</div>
											<div className="d-flex justify-content-between">
												<div className="d-flex">
													<div className="chart-legend-color bg-danger"></div>
													{t('delivery')}
												</div>
												<div>{formatMoney(data.order_types.total_delivery)} %</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4 mb-3">
									<div className="card h-100">
										<div className="card-body">
											<div className="mb-3">
												<h4>{t('top_products')}</h4>
											</div>
											<div className="d-flex w-100">
												<div style={{ 'width': '60%' }}># {t('name2')}</div>
												<div className="text-center" style={{ 'width': '20%' }}>{t('quantity')}</div>
												<div className="text-end" style={{ 'width': '20%' }}>{t('yesterday')}</div>
											</div>
											{data?.top_products?.map((item, index) => (
												<div className="d-flex w-100 mb-2" key={index}>
													<div style={{ 'width': '60%' }}>{index + 1} {item.name}</div>
													<div className="text-center" style={{ 'width': '20%' }}>{formatMoney(item.today_total_quantity)}</div>
													<div className="text-end" style={{ 'width': '20%' }}>
														{item.percentage > 0 ?
															<div className="nowrap text-success">
																<i className="uil uil-arrow-growth"></i>
																{formatMoney(item.percentage)} %
															</div>
															:
															<div className="nowrap text-danger">
																<i className="uil uil-chart-down"></i>
																{formatMoney(item.percentage)} %
															</div>
														}
													</div>
												</div>
											))}
										</div>
									</div>
								</div>
								<div className="col-md-4 mb-3">
									{loader ?
										<Skeleton height={450} />
										:
										<div className="card h-100">
											<div className="card-body">
												<div className="mb-3">
													<h4>{t('expenses')}</h4>
												</div>
												<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
													<table className="table table-bordered table-hover mb-0">
														<thead>
															<tr>
																<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
																<th style={{ 'width': '100%' }}>{t('name2')}</th>
																<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
																<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
																<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
															</tr>
														</thead>
														<tbody>
															{data?.expenses?.map((item, index) => (
																<tr key={index}>
																	<td className="text-center">{index + 1}</td>
																	<td className="td-ellipsis" title={item.name}>
																		{item.name}
																	</td>
																	<td className="text-end">{formatMoney(item.total_quantity)}</td>
																	<td className="text-end">{formatMoney(item.total_amount)}</td>
																	<td className="text-end">{formatMoney(item.percentage, 2)}</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									}
								</div>

								<div className="col-md-4">
									{loader ?
										<Skeleton height={450} />
										:
										<div className="card h-100">
											<div className="card-body">
												<div className="mb-3">
													<h4>KPI</h4>
												</div>
												<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
													<table className="table table-bordered table-hover mb-0">
														<thead>
															<tr>
																<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
																<th style={{ 'width': '100%' }}>{t('employee')}</th>
																<th style={{ 'minWidth': '100px' }} className="text-end">{t('scores')}</th>
															</tr>
														</thead>
														<tbody>
															{data?.employees?.map((item, index) => (
																<tr key={index}>
																	<td className="text-center">{index + 1}</td>
																	<td className="td-ellipsis" title={item.employee_name}>
																		{item.employee_name}
																	</td>
																	<td className="text-end">{formatMoney(item.total_score)}</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									}
								</div>
							</div>
						</>
					}
					{loader &&
						<>
							<div className="row mb-3">
								<div className="col-md-3">
									<Skeleton height={90.2} />
								</div>
								<div className="col-md-3">
									<Skeleton height={90.2} />
								</div>
								<div className="col-md-3">
									<Skeleton height={90.2} />
								</div>
								<div className="col-md-3">
									<Skeleton height={90.2} />
								</div>
							</div>

							<div className="row mb-3">
								<div className="col-md-12">
									<Skeleton height={300} />
								</div>
							</div>

							<div className="row mb-5">
								<div className="col-md-4">
									<Skeleton height={450} />
								</div>
								<div className="col-md-4">
									<Skeleton height={450} />
								</div>
								<div className="col-md-4">
									<Skeleton height={450} />
								</div>
							</div>
						</>
					}
				</>
			}
		</>
	)
}

export default Index
